import { get as getLocalStorage, set as setLocalStorage } from 'lib/storage/isomorphicLocalStorage'

export function get<T>(key: string, version: number): T | null {
  const item = getLocalStorage(key)
  if (item?.version !== version) { return null }
  return item.value
}

export function set<T>(key: string, version: number, value: T) {
  setLocalStorage(key, { version, value })
}

export { remove } from 'lib/storage/isomorphicLocalStorage'
